import React from "react";
import { VariantBase } from "~/components/newsletter/newsletter-widget/variants/component";
import { Container, theme } from "./styles";
export const PostiesTheme = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(VariantBase, {
  theme: theme,
  "data-qa": "posties-theme"
}, /*#__PURE__*/React.createElement(Container, props, children));
PostiesTheme.displayName = "PostiesTheme";